// extracted by mini-css-extract-plugin
module.exports = {"currencyRoot":"CwCurrencyField-currencyRoot","currencyText":"CwCurrencyField-currencyText","currencyCode":"CwCurrencyField-currencyCode"};